/* eslint-disable @typescript-eslint/no-explicit-any */
import { WarehouseStock } from '../model/models-module';
import BaseService from './BaseService';

export default class WarehouseStockService extends BaseService {
  private static _instance: WarehouseStockService

  public static get Instance() {
    return this._instance || (this._instance = new this())
  }

  async updateById(id: number, body: WarehouseStock) {
    try {
      const response = await this.client({
        url: `/warehouses-stocks/updateByID/${id}`,
        method: 'PATCH',
        data: body,
      })

      return response.data.data
    } catch (err: any) {
      this.handleError(err)
      throw err
    }
  }

}